const Header = () => {
    return (
        <header className="container app-header">
            <h4>Custom Hamper Gift Card Generator</h4>    
        </header>
    )
}

export default Header